<li class="nav-item">
  <a class="nav-link" href="#" role="button" aria-label="Toggle" (click)="toggle($event)"><fa-icon [icon]="['far', 'bell']"></fa-icon></a>
  <span class="notification-count animated heartBeat infinite delay-5s"
        *ngIf="count > 0">
    {{ count }}
  </span>
</li>

<div class="notification-backdrop"
     [class.visible]="isShown"
     role="button"
     arial-label="Close"
     (click)="toggle($event)">
</div>

<div class="notification-panel" [class.visible]="isShown">
  <h4 class="title">{{'COMMON.labels.notifications' | translate }}</h4>

  <div class="notifications-area">
    <div *ngFor="let notification of data" class="notification-item">
      <div class="creator">{{ notification.creator }}</div>
      <div class="content">{{ notification.content }}</div>
      <div class="created">{{ notification.created }}</div>
    </div>
  </div>

</div>
